import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { ENDPOINTS, apiFetch } from "../api/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("solvio_token");
    if (!token) { setLoading(false); return; }

    apiFetch(ENDPOINTS.me, { token })
      .then((data) => setUser(data))
      .catch(() => localStorage.removeItem("solvio_token"))
      .finally(() => setLoading(false));
  }, []);

  // ── Login with email + password ──
  const login = useCallback(async (email, password) => {
    const data = await apiFetch(ENDPOINTS.login, {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
    localStorage.setItem("solvio_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  // ── Register new account ──
  const register = useCallback(async (username, email, password) => {
    const data = await apiFetch(ENDPOINTS.register, {
      method: "POST",
      body: JSON.stringify({ username, email, password }),
    });
    localStorage.setItem("solvio_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  // ── Google OAuth login/register ──
  const googleLogin = useCallback(async (credentialToken) => {
    const data = await apiFetch(ENDPOINTS.googleAuth, {
      method: "POST",
      body: JSON.stringify({ token: credentialToken }),
    });
    localStorage.setItem("solvio_token", data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  // ── Logout ──
  const logout = useCallback(() => {
    localStorage.removeItem("solvio_token");
    setUser(null);
  }, []);

  const getToken = useCallback(() => localStorage.getItem("solvio_token"), []);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, googleLogin, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
};